import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

export const getSuggestions = createSelector(
  (state: RootState) => state.jobs.jobs,
  (jobs) => {
    const names = new Set<string>();
    const regions = new Set<string>();
    const creators = new Set<string>();
    const assignees = new Set<string>();
    const openedBy = new Set<string>();
    const organizationsOwnedBy = new Set<string>();
    const sharedWithOrganizations = new Set<string>();
    const locations = new Set<string>();
    const contactNames = new Set<string>();
    const contactEmails = new Set<string>();
    for (const job of jobs) {
      names.add(job.name);
      job.regions.forEach((region) => regions.add(region));
      if (job.creator != null) {
        creators.add(`${job.creator.firstName} ${job.creator.lastName}`);
      }
      if (job.assignedTo && job.assignedTo.length) {
        job.assignedTo.forEach((assigneeUser) => assignees.add(`${assigneeUser.firstName} ${assigneeUser.lastName}`));
      }
      if (job.openedBy != null && job.openedBy.length > 0) {
        job.openedBy.map((opener) => openedBy.add(`${opener.firstName} ${opener.lastName}`));
      }
      organizationsOwnedBy.add(job.ownerOrganization);
      if (job.sharedWithOrganizations != null && job.sharedWithOrganizations.length > 0) {
        job.sharedWithOrganizations.map((organization) => sharedWithOrganizations.add(organization));
      }
      if (job.location != null) {
        locations.add(job.location);
      }
      if (job.contactName != null) {
        contactNames.add(job.contactName);
      }
      if (job.contactEmail != null) {
        // job.contactEmail could be a comma-separated string of values, but the user may be looking for the combination,
        // so do not split them up
        contactEmails.add(job.contactEmail.toLowerCase());
      }
    }

    return {
      name: Array.from(names),
      regions: Array.from(regions),
      jobType: ['Seal', 'Repair', 'Special Engineering'],
      creator: Array.from(creators),
      assignedTo: Array.from(assignees),
      openedBy: Array.from(openedBy),
      organizationOwnedBy: Array.from(organizationsOwnedBy),
      jobStatus: ['Waiting', 'On Hold', 'Complete', 'In Process', 'Review', 'Cancelled', 'Errored'],
      jobPriority: ['Low', 'Normal', 'High'],
      sharedWithOrganizations: Array.from(sharedWithOrganizations),
      billingLocation: Array.from(locations),
      contactNames: Array.from(contactNames),
      contactEmails: Array.from(contactEmails),
    };
  },
);
